import gql from 'graphql-tag'

export const GET_BRANDS_FOR_PURCHASE = gql`
  query AllBrandsForPurchaseV2 {
    allBrandsForPurchase {
      avatar {
        cloudinaryId
        cloudinaryType
      }
      city {
        name
        uuid
      }
      country {
        name
        uuid
      }
      tradingName
      status
      videoProjectsCount
      subbrandType
      uuid
      id
      country {
        currencyCode
        currencySymbol
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/GetBrandsForPurchase.tsx